import { ReactNode, useContext, useMemo } from "react";

import { AbilityContext } from "./ability-context";
import { AbilityObject, Actions } from "./config";

interface Props {
  children: ReactNode;
  I: Actions;
  on: string;
}

function can({ ability, I }: { ability: AbilityObject; I: Actions }) {
  if (!ability) {
    return false;
  }

  return ability.ability.includes(I);
}

const Can = ({ children, I, on }: Props) => {
  const abilities = useContext(AbilityContext);
  const ability = useMemo(() => {
    if (!abilities) return undefined;

    return abilities.find((ab) => ab.module === on);
  }, [JSON.stringify(abilities), on]);

  if (ability && can({ I, ability })) {
    return <>{children}</>;
  }

  return null;
};

export default Can;
